import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
export class Lightmap {
    get lightmapColor() {
        return this._lightmapColor;
    }
    set lightmapColor(value) {
        if (this._lightmapColor == value)
            return;
        this._lightmapColor && this._lightmapColor._removeReference();
        this._lightmapColor = value;
        if (value) {
            value._addReference();
            this._dataModule.lightmapColor = value._texture;
        }
        else {
            this._dataModule.lightmapColor = null;
        }
    }
    get lightmapDirection() {
        return this._lightmapDirection;
    }
    set lightmapDirection(value) {
        if (this._lightmapDirection == value)
            return;
        this._lightmapDirection && this._lightmapDirection._removeReference();
        this._lightmapDirection = value;
        if (value) {
            value._addReference();
            this._dataModule.lightmapDirection = value._texture;
        }
        else {
            this._dataModule.lightmapDirection = null;
        }
    }
    constructor() {
        this._dataModule = Laya3DRender.Render3DModuleDataFactory.createLightmapData();
    }
}
Lightmap.ApplyLightmapEvent = "ApplyLightmap";
